import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-service-not-available',
  templateUrl: './service-not-available.component.html',
  styleUrl: './service-not-available.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ServiceNotAvailableComponent {

  constructor(
    private modalService: NgbModal,
  ) {
    this.modalService.dismissAll();
  }
}
